import React from 'react'
import Menu from '../component/Menu';
import HeaderService from '../component/HeaderService'
import Getintouch2 from '../component/Getintouch2'
import Servicebody from '../component/Servicebody'
import FooterNew from '../component/FooterNew'; 
import { Helmet } from 'react-helmet';
import ServiceDesc from '../component/ServiceDesc';

const serviceDes = {
    description:
      "Be it family offices, fund managers, advisors or corporates, we have enabled them to navigate the complexities of creating value and achieving sustainable growth",

    stats: [
      {
        title: "150+",
        text: "Clients Served",
      },
      {
        title: "$1Tn+",
        text: "Advised AUM",
      },
      {
        title: "20+",
        text: "Geographies Served",
      },
      {
        title: "300+",
        text: "Team Size",
      }, 
    ],
    class:"service-page-des",

  };


const Service = ({setBlank}) => {
  return (
    <>
    <Helmet>
      <title>Services - Preferred Square</title>
      <meta property="og:title" content="Services" />
      <meta name='og:description' content='Services'/>
      <meta name='keywords' content=''/>
    </Helmet>
      <Menu setBlank={setBlank} />
      <HeaderService />
      <ServiceDesc serviceDes={serviceDes} />
      <Servicebody setBlank={setBlank} />
      <Getintouch2 setBlank={setBlank} />
      <FooterNew setBlank={setBlank} />
    </>
  )
}

export default Service